module.exports = __webpack_public_path__ + "img/underline.59f7cb4f.svg";